import URIS from 'constants/uris';
import http from 'services/http';

export function createUserEvent(params) {
  return http.post(URIS.USER_EVENTS, params);
}
